module.exports = __webpack_public_path__ + "static/img/bianzu.840ef56.png";